function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "User / Users_Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M22.6667 26.666C22.6667 24.4569 19.6819 22.666 16 22.666C12.3181 22.666 9.33333 24.4569 9.33333 26.666M28 22.6665C28 21.0263 26.3545 19.6166 24 18.9993M4 22.6665C4 21.0263 5.64546 19.6166 8 18.9993M24 13.6475C24.8183 12.9151 25.3333 11.8507 25.3333 10.666C25.3333 8.45688 23.5425 6.66602 21.3333 6.66602C20.3089 6.66602 19.3743 7.05115 18.6667 7.68454M8 13.6475C7.18167 12.9151 6.66667 11.8507 6.66667 10.666C6.66667 8.45688 8.45753 6.66602 10.6667 6.66602C11.6911 6.66602 12.6257 7.05115 13.3333 7.68454M16 18.666C13.7909 18.666 12 16.8752 12 14.666C12 12.4569 13.7909 10.666 16 10.666C18.2091 10.666 20 12.4569 20 14.666C20 16.8752 18.2091 18.666 16 18.666Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var SvgPeople = function SvgPeople(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPeople, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/people.77ccc09d.svg";
export { ForwardRef as ReactComponent };